import React from 'react';
import { FileText, TrendingDown, Clock, CheckCircle, AlertCircle, Package, DollarSign, RotateCcw, Download, TrendingUp, Users, Calendar, Activity } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
interface HomeProps {
  onNavigate: (page: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <div className="space-y-6" data-id="element-2145">
      {/* Cooperative Header - Enhanced */}
      <div className="bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900 rounded-xl p-6 text-white shadow-xl relative overflow-hidden" data-id="element-2146">
        {/* Background Pattern */}
        <div className="absolute top-0 right-0 w-64 h-64 opacity-5" data-id="element-2147">
          <Users className="w-full h-full" data-id="element-2148" />
        </div>

        <div className="relative z-10" data-id="element-2149">
          <div className="flex justify-between items-start mb-6" data-id="element-2150">
            <div data-id="element-2151">
              <p className="text-slate-300 text-xs font-medium mb-1 uppercase tracking-wide" data-id="element-2152">
                Dashboard Procurement
              </p>
              <h2 className="text-2xl font-bold" data-id="element-2153">Koperasi Maju Jaya</h2>
              <p className="text-slate-400 text-sm mt-1" data-id="element-2154">ID: KOP-2023-MJ-001</p>
            </div>
            <div className="text-right" data-id="element-2155">
              <Badge className="bg-green-500 text-white border-0 mb-2" data-id="element-2156">
                Aktif
              </Badge>
              <p className="text-xs text-slate-400" data-id="element-2157">Member sejak Jan 2023</p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4" data-id="element-2158">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20" data-id="element-2159">
              <p className="text-slate-300 text-xs mb-1" data-id="element-2160">Limit Kredit</p>
              <p className="font-bold text-xl" data-id="element-2161">Rp 50.000.000</p>
              <div className="mt-2 flex items-center justify-between" data-id="element-2162">
                <p className="text-xs text-emerald-300" data-id="element-2163">Tersedia: Rp 37.5M</p>
                <span className="text-xs font-bold text-emerald-300" data-id="element-2164">75%</span>
              </div>
              <div className="mt-2 w-full h-1.5 bg-white/20 rounded-full overflow-hidden" data-id="element-2165">
                <div className="h-full bg-emerald-400 rounded-full" style={{
                width: '75%'
              }} data-id="element-2166"></div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20" data-id="element-2167">
              <p className="text-slate-300 text-xs mb-1" data-id="element-2168">Tagihan Berjalan</p>
              <p className="font-bold text-xl" data-id="element-2169">Rp 12.500.000</p>
              <div className="mt-2 flex items-center justify-between" data-id="element-2170">
                <p className="text-xs text-amber-300" data-id="element-2171">Jatuh Tempo: NET 30</p>
                <Badge className="bg-amber-500 text-white text-xs border-0" data-id="element-2172">
                  15 hari
                </Badge>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20" data-id="element-2173">
              <p className="text-slate-300 text-xs mb-1" data-id="element-2174">Jumlah Anggota</p>
              <p className="font-bold text-xl" data-id="element-2175">450 Orang</p>
              <div className="mt-2 flex items-center gap-2" data-id="element-2176">
                <Activity className="w-4 h-4 text-blue-300" data-id="element-2177" />
                <p className="text-xs text-blue-300" data-id="element-2178">+12 bulan ini</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Budget Alert */}
      <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4" data-id="element-2179">
        <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-2180" />
        <div className="flex-1" data-id="element-2181">
          <h4 className="font-bold text-amber-900 text-sm mb-1" data-id="element-2182">
            Peringatan Budget
          </h4>
          <p className="text-xs text-amber-700 leading-relaxed" data-id="element-2183">
            Anda telah menggunakan 75% dari limit kredit bulan ini. Sisa budget:
            Rp 12.5M
          </p>
        </div>
        <Button variant="outline" size="sm" className="text-amber-700 border-amber-300 hover:bg-amber-100" data-id="element-2184">
          Lihat Detail
        </Button>
      </div>

      {/* Quick Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2185">
        <Card className="p-4 text-center border-l-4 border-l-blue-500 hover:shadow-lg transition-shadow cursor-pointer" onClick={() => onNavigate('orders')} data-id="element-2186">
          <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-sm" data-id="element-2187">
            <Clock className="w-6 h-6" data-id="element-2188" />
          </div>
          <p className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2189">3</p>
          <p className="text-xs text-slate-500 font-medium" data-id="element-2190">Pending PO</p>
        </Card>

        <Card className="p-4 text-center border-l-4 border-l-green-500 hover:shadow-lg transition-shadow cursor-pointer" onClick={() => onNavigate('orders')} data-id="element-2191">
          <div className="w-12 h-12 bg-green-50 text-green-600 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-sm" data-id="element-2192">
            <CheckCircle className="w-6 h-6" data-id="element-2193" />
          </div>
          <p className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2194">8</p>
          <p className="text-xs text-slate-500 font-medium" data-id="element-2195">Dalam Transit</p>
        </Card>

        <Card className="p-4 text-center border-l-4 border-l-amber-500 hover:shadow-lg transition-shadow" data-id="element-2196">
          <div className="w-12 h-12 bg-amber-50 text-amber-600 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-sm" data-id="element-2197">
            <TrendingDown className="w-6 h-6" data-id="element-2198" />
          </div>
          <p className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2199">15%</p>
          <p className="text-xs text-slate-500 font-medium" data-id="element-2200">Penghematan</p>
        </Card>

        <Card className="p-4 text-center border-l-4 border-l-violet-500 hover:shadow-lg transition-shadow" data-id="element-2201">
          <div className="w-12 h-12 bg-violet-50 text-violet-600 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-sm" data-id="element-2202">
            <TrendingUp className="w-6 h-6" data-id="element-2203" />
          </div>
          <p className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2204">92%</p>
          <p className="text-xs text-slate-500 font-medium" data-id="element-2205">On-Time Rate</p>
        </Card>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-3 gap-3" data-id="element-2206">
        <Button variant="primary" size="lg" fullWidth onClick={() => onNavigate('catalog')} className="h-auto py-4 flex-col gap-2 shadow-lg shadow-blue-200" data-id="element-2207">
          <Package className="w-6 h-6" data-id="element-2208" />
          <span className="text-sm" data-id="element-2209">Buat Requisition</span>
        </Button>

        <Button variant="outline" size="lg" fullWidth onClick={() => onNavigate('history')} className="h-auto py-4 flex-col gap-2" data-id="element-2210">
          <RotateCcw className="w-6 h-6" data-id="element-2211" />
          <span className="text-sm" data-id="element-2212">Pesan Ulang</span>
        </Button>

        <Button variant="outline" size="lg" fullWidth onClick={() => onNavigate('orders')} className="h-auto py-4 flex-col gap-2" data-id="element-2213">
          <FileText className="w-6 h-6" data-id="element-2214" />
          <span className="text-sm" data-id="element-2215">Lihat Semua PO</span>
        </Button>
      </div>

      {/* Recent Purchase Orders */}
      <div className="space-y-3" data-id="element-2216">
        <div className="flex items-center justify-between" data-id="element-2217">
          <h3 className="font-bold text-slate-800 text-lg" data-id="element-2218">
            Purchase Order Terbaru
          </h3>
          <button onClick={() => onNavigate('orders')} className="text-blue-600 text-sm font-bold hover:text-blue-700 transition-colors" data-id="element-2219">
            Lihat Semua →
          </button>
        </div>

        <Card className="divide-y divide-slate-100" data-id="element-2220">
          <div className="p-4 flex items-start justify-between hover:bg-slate-50 transition-colors cursor-pointer" onClick={() => onNavigate('tracking')} data-id="element-2221">
            <div className="flex-1" data-id="element-2222">
              <div className="flex items-center gap-2 mb-2" data-id="element-2223">
                <h4 className="font-bold text-slate-900" data-id="element-2224">PO-2023-001</h4>
                <Badge variant="warning" data-id="element-2225">Dalam Pengiriman</Badge>
              </div>
              <p className="text-xs text-slate-500 mb-2" data-id="element-2226">
                Dibuat: 10 Okt 2023 • ETA: 12 Okt 2023
              </p>
              <div className="flex items-center gap-4 text-xs" data-id="element-2227">
                <span className="text-slate-600" data-id="element-2228">32 SKU</span>
                <span className="text-slate-400" data-id="element-2229">•</span>
                <span className="font-bold text-slate-900" data-id="element-2230">Rp 4.500.000</span>
              </div>
            </div>
            <div className="flex flex-col gap-2" data-id="element-2231">
              <Button size="sm" variant="primary" data-id="element-2232">
                Lacak
              </Button>
              <Button size="sm" variant="outline" icon={<Download className="w-3 h-3" data-id="element-2234" />} data-id="element-2233">
                PDF
              </Button>
            </div>
          </div>

          <div className="p-4 flex items-start justify-between hover:bg-slate-50 transition-colors" data-id="element-2235">
            <div className="flex-1" data-id="element-2236">
              <div className="flex items-center gap-2 mb-2" data-id="element-2237">
                <h4 className="font-bold text-slate-900" data-id="element-2238">PO-2023-002</h4>
                <Badge variant="success" data-id="element-2239">Terkirim</Badge>
              </div>
              <p className="text-xs text-slate-500 mb-2" data-id="element-2240">Selesai: 8 Okt 2023</p>
              <div className="flex items-center gap-4 text-xs" data-id="element-2241">
                <span className="text-slate-600" data-id="element-2242">18 SKU</span>
                <span className="text-slate-400" data-id="element-2243">•</span>
                <span className="font-bold text-slate-900" data-id="element-2244">Rp 2.100.000</span>
              </div>
            </div>
            <div className="flex flex-col gap-2" data-id="element-2245">
              <Button size="sm" variant="outline" icon={<RotateCcw className="w-3 h-3" data-id="element-2247" />} data-id="element-2246">
                Pesan Ulang
              </Button>
              <Button size="sm" variant="outline" icon={<Download className="w-3 h-3" data-id="element-2249" />} data-id="element-2248">
                PDF
              </Button>
            </div>
          </div>
        </Card>
      </div>

      {/* Monthly Summary */}
      <div className="grid grid-cols-2 gap-4" data-id="element-2250">
        <Card className="p-5 bg-slate-50 border-slate-200" data-id="element-2251">
          <div className="flex items-center gap-3 mb-4" data-id="element-2252">
            <div className="w-10 h-10 bg-slate-600 rounded-lg flex items-center justify-center" data-id="element-2253">
              <DollarSign className="w-5 h-5 text-white" data-id="element-2254" />
            </div>
            <h3 className="font-bold text-slate-800" data-id="element-2255">Ringkasan Bulan Ini</h3>
          </div>
          <div className="space-y-3" data-id="element-2256">
            <div data-id="element-2257">
              <p className="text-xs text-slate-500 mb-1" data-id="element-2258">Total Pengeluaran</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-2259">Rp 18.200.000</p>
            </div>
            <div data-id="element-2260">
              <p className="text-xs text-slate-500 mb-1" data-id="element-2261">Jumlah Pesanan</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-2262">12 PO</p>
            </div>
          </div>
        </Card>

        <Card className="p-5 bg-blue-50 border-blue-200" data-id="element-2263">
          <div className="flex items-center gap-3 mb-4" data-id="element-2264">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-2265">
              <TrendingUp className="w-5 h-5 text-white" data-id="element-2266" />
            </div>
            <h3 className="font-bold text-blue-800" data-id="element-2267">Performa</h3>
          </div>
          <div className="space-y-3" data-id="element-2268">
            <div data-id="element-2269">
              <p className="text-xs text-blue-600 mb-1" data-id="element-2270">
                Penghematan Rata-rata
              </p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-2271">15%</p>
            </div>
            <div data-id="element-2272">
              <p className="text-xs text-blue-600 mb-1" data-id="element-2273">Ketepatan Waktu</p>
              <p className="text-2xl font-bold text-blue-900" data-id="element-2274">92%</p>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}